var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { useBreakpoint, getTestId, Collapsible, Button } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getCollapsibleSectionStyles } from './CollapsibleSectionStyles';
export var OverviewCardCollapsibleSection = _a => {
  var children = _a.children,
    _a$collapsedCtaText = _a.collapsedCtaText,
    collapsedCtaText = _a$collapsedCtaText === void 0 ? 'View More' : _a$collapsedCtaText,
    _a$expandedCtaText = _a.expandedCtaText,
    expandedCtaText = _a$expandedCtaText === void 0 ? 'View Less' : _a$expandedCtaText,
    _a$collapsedCtaIcon = _a.collapsedCtaIcon,
    collapsedCtaIcon = _a$collapsedCtaIcon === void 0 ? 'DownChevronIcon' : _a$collapsedCtaIcon,
    _a$expandedCtaIcon = _a.expandedCtaIcon,
    expandedCtaIcon = _a$expandedCtaIcon === void 0 ? 'UpChevronIcon' : _a$expandedCtaIcon,
    onTogglePressMetaData = _a.onTogglePressMetaData,
    collapsibleProps = _a.collapsibleProps,
    onUserAction = _a.onUserAction,
    props = __rest(_a, ["children", "collapsedCtaText", "expandedCtaText", "collapsedCtaIcon", "expandedCtaIcon", "onTogglePressMetaData", "collapsibleProps", "onUserAction"]);
  var collapsibleRef = useRef(null);
  var _useBreakpoint = useBreakpoint(),
    breakpoint = _useBreakpoint.breakpoint;
  var collapsibleSummaryWidgetStyles = getCollapsibleSectionStyles();
  var _useState = useState(false),
    isCollapsibleOpen = _useState[0],
    setIsCollapsibleOpen = _useState[1];
  var isLargeScreen = breakpoint !== 'xs' && breakpoint !== 'sm';
  var onTogglePress = () => {
    var _a;
    onTogglePressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onTogglePressMetaData), props));
    (_a = collapsibleRef === null || collapsibleRef === void 0 ? void 0 : collapsibleRef.current) === null || _a === void 0 ? void 0 : _a.toggle();
    setIsCollapsibleOpen(!isCollapsibleOpen);
  };
  return _jsxs(View, Object.assign({}, getTestId(props === null || props === void 0 ? void 0 : props.testID), {
    children: [_jsx(Collapsible, Object.assign({
      ref: collapsibleRef,
      showIcon: false,
      version: "variable-width",
      childNoHorizontalPadding: true,
      childNoVerticalPadding: true,
      titleNoVerticalPadding: true,
      titleNoHorizontalPadding: true
    }, collapsibleProps, {
      children: children
    })), _jsx(Button, Object.assign({
      size: isLargeScreen ? 'md' : 'sm',
      style: collapsibleSummaryWidgetStyles === null || collapsibleSummaryWidgetStyles === void 0 ? void 0 : collapsibleSummaryWidgetStyles.button,
      iconName: isCollapsibleOpen ? expandedCtaIcon : collapsedCtaIcon,
      iconPosition: "right",
      buttonType: "tertiary",
      version: "variable-width",
      title: isCollapsibleOpen ? expandedCtaText : collapsedCtaText,
      onPress: onTogglePress
    }, isCollapsibleOpen ? props === null || props === void 0 ? void 0 : props.expandedCtaAccessibilityProps : props === null || props === void 0 ? void 0 : props.collapsedCtaAccessibilityProps))]
  }));
};